// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import moment from 'moment'
import React from 'react'
import EditButton from '../../common/iconButtons/EditButton'
import { PreformattedTooltip } from '../../common/PreformattedTooltip'
import css from './BudgetTable.css'
import type { BudgetPlanItem, ForecastSalesItem, PlanItem, PlanNote } from './types'

type DayRowGridProps = {
  date: string
  type: string
  value: number
  editable: boolean
  onAmountChange: (...args: Array<any>) => any
}

const DayRowGrid = ({ date, type, value, editable, onAmountChange }: DayRowGridProps) => {
  return (
    <td>
      {editable ? (
        <input
          className={css.tableInput}
          type='number'
          placeholder='0'
          value={value || ''}
          min={0}
          onChange={(e) => onAmountChange(e, date, type)}
        />
      ) : (
        value.toFixed(0) || '0'
      )}
    </td>
  )
}

type DayRowProps = {
  budget: BudgetPlanItem
  forecast: ForecastSalesItem
  plan: PlanItem
  editable: boolean
  onAmountChange: (...args: Array<any>) => any
  isStationPage: boolean
  stationId: string
  onNoteDialogOpen: (...args: Array<any>) => any
}

const DayRow = ({
  budget: { date, budgetedSales, budgetedHours },
  forecast: { sales: forecastSales },
  plan: { plannedHours, plannedSales, note },
  editable,
  onAmountChange,
  isStationPage,
  stationId,
  onNoteDialogOpen,
}: DayRowProps) => {
  const onClickEditNote = (note: PlanNote | null) => {
    if (note) {
      onNoteDialogOpen(note)
    } else {
      const emptyNote = {
        id: null,
        note: '',
        date,
      }
      onNoteDialogOpen(emptyNote)
    }
  }

  return (
    <React.Fragment>
      <tr className={css.tableRow}>
        <td>{moment(date).format('D.M. - dd')}</td>
        <DayRowGrid date={date} type='budgetedSales' value={budgetedSales} />
        <DayRowGrid date={date} type='budgetedHours' value={budgetedHours} />
        {/* Forecast and planned sales & hours columns will be shown on Total page */}
        {isStationPage && <DayRowGrid date={date} type='forecastSales' value={forecastSales} />}
        <DayRowGrid
          date={date}
          type='plannedSales'
          value={plannedSales}
          editable={editable}
          onAmountChange={onAmountChange}
        />
        <DayRowGrid
          date={date}
          type='plannedHours'
          value={plannedHours}
          editable={editable}
          onAmountChange={onAmountChange}
        />
        <td>{plannedHours ? (plannedSales / plannedHours).toFixed(0) : '-'}</td>
        <td className={css.noteContainer}>
          <PreformattedTooltip title={note ? note.note : ''}>
            <div className={css.note} onClick={() => onClickEditNote(note)}>
              {note ? note.note : ''}
            </div>
          </PreformattedTooltip>
          <EditButton onClick={() => onClickEditNote(note)} />
        </td>
      </tr>
    </React.Fragment>
  )
}

export default DayRow
